/**
 * Теры ВЗП, которые отмечаются у набора после боя.
 *
 * Это базовый список — кнопки на странице набора. Тера, вписанная вручную
 * (на 5х5 бывают свои), сохраняется у набора и дальше показывается кнопкой
 * наравне с этими: список собирается из базового и уже использованных.
 */
export const VZP_TERRITORIES: readonly string[] = [
  'Сенди Шорс (Б)',
  'Биз стройка (Б)',
  'Палето Бей (Б)',
  'Ветряки (Б)',
  'Миррор Парк (Б)',
  'Татушка (Б)',
  'Муравейник (Б)',
  'Лесопилка (Б)',
  'Киностудия (Б)',
];

/** Предел длины своей теры: название, а не описание. */
export const TERRITORY_MAX_LENGTH = 60;

/** Статистика по одной тере. Винрейт считается только по победам и поражениям. */
export interface TerritoryStats {
  territory: string;
  wins: number;
  losses: number;
  afk: number;
}

/**
 * Базовый список плюс уже использованные теры, без повторов: сначала базовые
 * в своём порядке, потом свои по алфавиту.
 */
export function mergeTerritories(used: readonly string[]): string[] {
  const custom = [...new Set(used)]
    .filter((territory) => !VZP_TERRITORIES.includes(territory))
    .sort((left, right) => left.localeCompare(right, 'ru'));
  return [...VZP_TERRITORIES, ...custom];
}

/** Доля побед в процентах или `null`, если ни побед, ни поражений нет. */
export function territoryWinrate(stats: Pick<TerritoryStats, 'wins' | 'losses'>): number | null {
  const decided = stats.wins + stats.losses;
  return decided === 0 ? null : Math.round((stats.wins / decided) * 100);
}
